import { type WebSection } from '@wbk/contentful/api';
import ExploreHeroSection from '../explore/Hero';
import EventsFullScreenCarousel from '../sections/common/FeaturedEvents';

import ErrorBoundary from '../error/ErrorBoundary';
import ExperiencesSection from '../sections/zones/Expericences';
import EventSectionWithPagination from '../sections/events/EventsSectionWithPagination';

type Props = {
  section?: WebSection;
};

const ExploreSections = ({ section }: Props) => {
  switch (section?.renderType) {
    case 'hero-image':
      return <ExploreHeroSection section={section} />;
    case 'fullwidth-carousel':
      return <EventsFullScreenCarousel section={section} />;
    case 'cards-grid':
      return <EventSectionWithPagination section={section} />;
    case 'cards':
      return (
        <ErrorBoundary fallback={<></>}>
          <ExperiencesSection section={section} initialLimit={4} titleClassName='max-w-sm' />
        </ErrorBoundary>
      );

    default:
      return;
  }
};

export default ExploreSections;
